/**
 * Render conditions, used to conditionally show content blocks to visitors
 *
 * LOGGED_IN: a logged in WAP member
 * GUEST: anyone who is not logged in
 */
export const RENDERCONDITION_LOGGED_IN_WITH_MEMBERSHIP = 'loggedInWithMembership';
export const RENDERCONDITION_LOGGED_IN_WITHOUT_MEMBERSHIP = 'loggedInWithoutMembership';
export const RENDERCONDITION_GUESTS = 'guests';
